import { Col, Row } from '@design-system/components/grid/grid';
import { ExtrasEmptyState } from './components/ExtrasEmptyState';
import { ExtrasHeader } from './components/ExtrasHeader';
import { ExtrasContent } from './components/ExtrasContent';
import { ExtrasForms } from './ExtrasForm.view';
import { PDFView } from './pdf/pdf.view';
import { LinkView } from './link/link.view';
import { LegacyGuideView } from './legacy-guide/legacy-guide.view';
import { SlidesView } from './slides/slides.view';
import { VideoView } from './video/video.view';
import { CommentsSideModal } from '../comments/comments.view';
import { extrasVM } from './Extras.page';

export const ExtrasView = () => {
  const vm = extrasVM.useValue();

  return (
    <Row>
      <Col gap="3xl" className="w-full">
        <PDFView />
        <LinkView key={vm.currentId} />
        <LegacyGuideView />
        <VideoView />
        <SlidesView />
        <ExtrasHeader />
        <ExtrasEmptyState />
        <ExtrasContent />
        <ExtrasForms />
        <CommentsSideModal
          contentId={vm.commentsContentId}
          onClose={() => vm.dispatch('CloseComments')}
        />
      </Col>
    </Row>
  );
};
